import { useEffect } from 'react';
import {
  Dialog,
  FlexColumn,
  TextField,
} from '@elementary/common-ui/components';
import { InputLabel } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

type FormData = {
  name: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  confirmText: string;
  initialName?: string;
  isLoading: boolean;
  onSubmit: (name: string) => Promise<unknown>;
};

const RuntimeNameDialog = ({
  isOpen,
  onClose,
  title,
  confirmText,
  initialName = '',
  isLoading,
  onSubmit,
}: Props) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid, isDirty },
  } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: { name: initialName },
  });

  useEffect(() => {
    if (isOpen) {
      reset({ name: initialName });
    }
  }, [isOpen, initialName, reset]);

  const submit = async ({ name }: FormData) => {
    await onSubmit(name.trim());
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      onConfirmButtonClick={handleSubmit(submit)}
      title={title}
      confirmText={confirmText}
      confirmDisabled={isLoading || !isValid || !isDirty}
      isLoading={isLoading}
      closeOnBackdropClick={false}
      message={
        <FlexColumn>
          <InputLabel shrink htmlFor="runtime-name">
            Name
          </InputLabel>
          <Controller
            name="name"
            control={control}
            rules={{
              required: true,
              validate: (value) => value.trim().length > 0,
            }}
            render={({ field }) => (
              <TextField
                {...field}
                id="runtime-name"
                size="large"
                placeholder="e.g. Production (Helm)"
                autoFocus
              />
            )}
          />
        </FlexColumn>
      }
    />
  );
};

export default RuntimeNameDialog;
